import fetch from '@/common/utils/serFetch'
import { GATEWAYSER } from '@/common/config'

const moduleList = {
  serviceProvider: `${GATEWAYSER.SQSIM}/serviceProvider`,
  customerStaffManager: `${GATEWAYSER.SQSIM}/customerStaffManager`
}

export const serviceProviderApi = {
  // 列表
  reqList(params) {
    return fetch.post(`${moduleList.serviceProvider}/page`, params)
  },
  // 服务商列表
  selectAllEnableList() {
    return fetch.get(`${moduleList.serviceProvider}/selectAllEnableList?size=9999&serviceType=1`)
  },
  // 获取服务商分流信息
  selectAllServiceQuota() {
    return fetch.get(`${moduleList.serviceProvider}/selectAllServiceQuota`)
  },
  // 设置服务商分流信息
  batchUpdateServiceQuota(params) {
    return fetch.post(`${moduleList.serviceProvider}/batchUpdateServiceQuota`, params)
  },
  // 新增
  insert(params) {
    return fetch.post(`${moduleList.serviceProvider}/add`, params)
  },
  // 修改
  update(params) {
    return fetch.post(`${moduleList.serviceProvider}/update`, params)
  },
  // 详情
  queryDetail(id) {
    return fetch.get(`${moduleList.serviceProvider}/detail?id=${id}`)
  },
  // 服务商名称
  queryProvider() {
    return fetch.get(`${moduleList.serviceProvider}/getConditionList`)
  },
  // 导出
  reqExcel: params => fetch.download(`${GATEWAYSER.SQSIM}/report/service_provider/export`, { ...params })
}
